// LooksAdminDashboard.js

import React, { useState, useEffect } from 'react';
import ManageUsers         from './ManageUsers';        // generic user-manager
import LooksViewReports    from './LooksViewReports';   // reports for looksReports
import LooksManagePosts    from './LooksManagePosts';   // CRUD for looksPosts
import {
  getAllContactSubmissions,          // ← generic helper (one collection for all apps)
  updatePostVerificationPassword
} from '../utils/dbUtilities';

import './AdminDashboard.css';

const LooksAdminDashboard = () => {
  /* ─────────────────────────── state ─────────────────────────── */
  const [activeTab,          setActiveTab]           = useState('posts');
  const [contactSubmissions, setContactSubmissions]  = useState([]);
  const [newPassword,        setNewPassword]         = useState('');
  const [confirmNewPassword, setConfirmNewPassword]  = useState('');

  /* ─────────────────────── load contact data ─────────────────── */
  useEffect(() => {
    getAllContactSubmissions()                            // ← updated helper
      .then(subs => {
        const sorted = subs.sort((a, b) => b.timestamp - a.timestamp);
        setContactSubmissions(sorted);
      })
      .catch(err => console.error('Failed to load contact submissions:', err));
  }, []);

  /* ───────────────────────── helpers ─────────────────────────── */
  const getTabClass = tab =>
    `admin-dashboard-tab-button ${activeTab === tab ? 'active' : ''}`;

  /* ────────────────────────── render ─────────────────────────── */
  return (
    <div className="admin-dashboard-container">
      {/* header */}
      <div className="admin-dashboard-header">
        <h1>Looks Admin Dashboard</h1>
      </div>

      {/* tab buttons */}
      <ul className="admin-dashboard-tabs">
        <li className={getTabClass('posts')}    onClick={() => setActiveTab('posts')}>Manage Posts</li>
        <li className={getTabClass('users')}    onClick={() => setActiveTab('users')}>Manage Users</li>
        <li className={getTabClass('reports')}  onClick={() => setActiveTab('reports')}>View Reports</li>
        <li className={getTabClass('contact')}  onClick={() => setActiveTab('contact')}>Contact Submissions</li>
        <li className={getTabClass('password')} onClick={() => setActiveTab('password')}>Post Verification Password</li>
      </ul>

      {/* tab content */}
      <div className="admin-dashboard-content">
        {activeTab === 'posts'   && <LooksManagePosts />}
        {activeTab === 'users'   && <ManageUsers />}
        {activeTab === 'reports' && <LooksViewReports />}

        {activeTab === 'contact' && (
          <div>
            <h2>Contact Form Submissions</h2>
            <div className="reports-list">
              {contactSubmissions.map(sub => (
                <div key={sub.id} className="report-item">
                  <p>From: {sub.name} ({sub.email})</p>
                  <p>Message: {sub.message}</p>
                  <p>Sent: {new Date(sub.timestamp).toLocaleString()}</p>
                </div>
              ))}
            </div>
          </div>
        )}

        {activeTab === 'password' && (
          <div>
            <h2>Change Post Verification Password</h2>
            <div>
              <label>
                New Password:&nbsp;
                <input
                  type="password"
                  value={newPassword}
                  onChange={e => setNewPassword(e.target.value)}
                  placeholder="Enter new password"
                />
              </label>
            </div>
            <div>
              <label>
                Confirm New Password:&nbsp;
                <input
                  type="password"
                  value={confirmNewPassword}
                  onChange={e => setConfirmNewPassword(e.target.value)}
                  placeholder="Confirm new password"
                />
              </label>
            </div>

            <button
              onClick={() => {
                if (!newPassword) return alert('Please enter a password.');
                if (newPassword !== confirmNewPassword) {
                  return alert('Passwords do not match.');
                }
                updatePostVerificationPassword(newPassword)
                  .then(() => {
                    alert('Password updated successfully.');
                    setNewPassword('');
                    setConfirmNewPassword('');
                  })
                  .catch(err => {
                    console.error('Failed to update password:', err);
                    alert('Error – see console for details.');
                  });
              }}
            >
              Update Password
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default LooksAdminDashboard;
